import { html } from "lit";
var icon_community_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      fill-rule="evenodd"
      d="M29 4a1 1 0 011 1v18l-.007.117A1 1 0 0129 24l-13.757-.001a.997.997 0 00-.707.293l-3.829 3.83a1 1 0 01-1.414 0l-3.83-3.83a1 1 0 00-.707-.293L3 24l-.117-.007A1 1 0 012 23V5a1 1 0 011-1zm-1 2H4v16h2l4 4 4-4h14V6zM17 16a1 1 0 010 2H9a1 1 0 010-2h8zm4-6a1 1 0 010 2H9a1 1 0 010-2h12z" />
  </svg>
`;
export {
  icon_community_default as default
};
//# sourceMappingURL=icon-community.js.map
